import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

export type TOfferLinkRel = 'noopener' | 'noreferrer';

/**
 * rel для ссылки на карточку объявления (открывается в новой вкладке).
 * Своей карточке отдаём referrer: по нему кнопка «назад» на карточке возвращает на выдачу.
 * Партнёрская ссылка ведёт на внешний сайт, ей referrer не отдаём.
 */
export const getOfferLinkRel = (offer: Pick<IDailyRentOfferForMobileSite, 'isCianPartner'>): TOfferLinkRel =>
  offer.isCianPartner ? 'noreferrer' : 'noopener';
